const pallete = {
  mode: 'dark',
  primary: {
    main: '#0C4072',
    dark: '#0d1013',
  },
  secondary: {
    light: '#e80b2c',
    main: '#b90722',
    dark: '#98041b',
  },
  error: {
    light: '#c6611b',
    main: '#c6372c',
    dark: '#c6372c',
    requiredQuiz: '#db3337',
    chipBackground: '#FFE6E7',
  },
  success: {
    light: '#51C768',
    main: '#3CBA54',
    dark: '#34A048',
    chipBackground: '#E1F5E5',
  },
  warning: {
    light: '#F5CA2D',
    main: '#F4C20D',
    dark: '#D5A90A',
    chipColor: '#F89239',
    chipBackground: '#FDEEE2',
  },
  gray: {
    G10: '#f9f9ff',
    G20: '#eeeeee',
  },
  text: {
    primary: '#FFFFFF',
    secondary: 'rgba(0,0,0,0.6)',
  },
  background: {
    primary: '#131313',
  },
};

export default pallete;
